"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _now = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/date/now"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Checkbox = _interopRequireDefault(require("../Checkbox/Checkbox"));

var _FormElementError = _interopRequireDefault(require("../Form/FormElementError"));

var _Label = _interopRequireDefault(require("../Label/Label"));

var _TextButton = _interopRequireDefault(require("../TextButton/TextButton"));

var _TextInput = _interopRequireDefault(require("../TextInput/TextInput"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

var PasswordControl = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(PasswordControl, _Component);

  var _super = _createSuper(PasswordControl);

  function PasswordControl(props) {
    var _this;

    (0, _classCallCheck2.default)(this, PasswordControl);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      showPassword: false,
      isValid: true
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_onPasswordFocus", function () {
      var onFocus = _this.props.onFocus;

      if (onFocus) {
        onFocus();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_onPasswordChange", function (evt) {
      _this.setState({
        value: evt.target.value,
        isValid: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_onInvalid", function (validationState) {
      var onInvalid = _this.props.onInvalid;

      _this.setState({
        isValid: validationState.valid
      });

      if (onInvalid) {
        onInvalid(validationState);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_onToggleShowPasswordChange", function () {
      _this._generateKey();

      _this.setState(function (prevState, props) {
        return {
          showPassword: !prevState.showPassword
        };
      });
    });
    var requiredError = props.requiredError,
        minLength = props.minLength;
    _this._pattern = minLength ? ".{".concat(minLength, ",}") : null;

    if (minLength) {
      _this._error = /*#__PURE__*/_react.default.createElement(_FormElementError.default, null, "Please enter at least ", minLength, " characters.");
    } else {
      _this._error = /*#__PURE__*/_react.default.createElement(_FormElementError.default, null, requiredError);
    }

    _this._generateKey();

    return _this;
  }

  (0, _createClass2.default)(PasswordControl, [{
    key: "_generateKey",
    value: function _generateKey() {
      this._key = "password-".concat((0, _now.default)());
    }
    /**
     * Provides the form data as an object for submission.
     *
     * @public
     * @returns {Object} - The form data to submit.
     */

  }, {
    key: "submit",
    value: function submit() {
      var value = this._input.node.value;
      return value ? {
        password: value
      } : null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          showCheckboxId = _this$props.showCheckboxId,
          showForgotPassword = _this$props.showForgotPassword,
          label = _this$props.label,
          placeholder = _this$props.placeholder,
          showPlaceholder = _this$props.showPlaceholder,
          helpNode = _this$props.helpNode,
          required = _this$props.required,
          onForgotPasswordClick = _this$props.onForgotPasswordClick;
      var _this$state = this.state,
          value = _this$state.value,
          showPassword = _this$state.showPassword,
          isValid = _this$state.isValid;
      var classes = (0, _classnames.default)('PasswordControl', 'FormElement', {
        'FormElement-contains-error': !isValid
      }, className);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classes
      }, label, /*#__PURE__*/_react.default.createElement("div", {
        className: "PasswordControl-input"
      }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
        key: this._key,
        ref: function ref(node) {
          _this2._input = node;
        },
        name: "password",
        type: showPassword ? 'text' : 'password',
        required: required,
        pattern: this._pattern,
        defaultValue: value,
        placeholder: showPlaceholder && placeholder ? placeholder : '',
        onChange: this._onPasswordChange,
        onInvalid: this._onInvalid,
        onFocus: this._onPasswordFocus
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "PasswordControl-show"
      }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
        id: showCheckboxId,
        label: /*#__PURE__*/_react.default.createElement(_Label.default, null, "Show"),
        onChange: this._onToggleShowPasswordChange
      }), /*#__PURE__*/_react.default.createElement(_TextButton.default, {
        onClick: this._onToggleShowPasswordChange
      }, showPassword ? 'Hide' : 'Show'))), helpNode && /*#__PURE__*/_react.default.createElement("div", {
        className: "FormElement-help-text"
      }, helpNode), !isValid && this._error, showForgotPassword && /*#__PURE__*/_react.default.createElement(_TextButton.default, {
        className: "PasswordControl-forgot",
        onClick: onForgotPasswordClick
      }, "Forgot Password?"));
    }
  }]);
  return PasswordControl;
}(_react.Component);

exports.default = PasswordControl;
(0, _defineProperty2.default)(PasswordControl, "defaultProps", {
  showCheckboxId: 'PasswordControl-show-password',
  showForgotPassword: true,
  required: true,
  requiredError: 'Please enter your password.'
});